module.exports = __webpack_public_path__ + "img/titleth.e8b98714.png";